import { __assign, __extends } from "tslib";
import React from "react";
import { Provider } from "react-redux";
import "../style/containers/reportBuilder.scss";
import "../style/index.scss";
import "../style/custom-colors.css";
import { ReportBuilder as ReportBuilderInner, } from "./components/ReportBuilder";
import { configureStore } from "./state/configureStore";
var store = configureStore();
var ReportBuilder = (function (_super) {
    __extends(ReportBuilder, _super);
    function ReportBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReportBuilder.prototype.render = function () {
        return (React.createElement(Provider, { store: store },
            React.createElement(ReportBuilderInner, __assign({}, this.props))));
    };
    return ReportBuilder;
}(React.PureComponent));
export { ReportBuilder };
